import React, { ReactNode, FC } from "react";

export interface CardProps {
    className?: string,
    children?: ReactNode
}
const Card: FC<CardProps> = (props) => {
    return (
        <div className={`a-card-user ${props.className}`}>
            {props.children}
        </div>
    );
};

export default Card;
